<template>
  <vs-sidebar
    default-index="1"
    :parent="parent"
    :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx"
    spacer
    v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']"
  >
    <vs-sidebar-group title="Sentenance" open>
      <vs-sidebar-item :to="'/overview'" index="1" icon="cloud_queue">
        Overview
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/dataExport'" index="2" icon="description">
        Report
      </vs-sidebar-item>

      <vs-sidebar-group open title="Dashboard">
        <vs-sidebar-item :to="'/officemate/I-Sentenance'" index="2.1.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/images/icon/logosentanance.png"
          />
          I-Sentenance
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/officemate/peopleCounting'" index="2.1.2">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/images/icon/sensorcound.png"
          />
          People Counting
        </vs-sidebar-item>
      </vs-sidebar-group>
      <vs-sidebar-group title="Device Mangement">
        <vs-sidebar-item :to="'/sensor'" index="2.2" icon="settings_remote">
          Device
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/gateway'" index="2.3" icon="router">
          Gateway
        </vs-sidebar-item>
      </vs-sidebar-group>
      <vs-sidebar-group title="Setting">
        <vs-sidebar-item :to="'/network'" index="2.2" icon="wifi">
          Network
        </vs-sidebar-item>
      </vs-sidebar-group>
    </vs-sidebar-group>

    <footer-sidebar slot="footer"> </footer-sidebar>
  </vs-sidebar>
</template>

<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "BetagroSidebar",
  components: {
    FooterSidebar,
  },
  data() {
    return {
      list_route: [
        "/overview",
        "/dataExport",
        "/EngineAssemblyLine",
        "/ConeveyerLine",
        "/BodyOutLine",
        "/sensor",
        "/gateway",
        "/network",
      ],

      interval: null,
    };
  },
  mounted() {
    // let current_route = this.$route.path
    // console.log(current_route);
    // console.log(this.list_route.indexOf(current_route));
    // let i = this.list_route.indexOf(current_route) + 1
    // this.interval = setInterval(() => {
    //   console.log('push',this.list_route[i]);
    //   this.$router.push({ path: this.list_route[i] })
    //   i++
    //   if (i >= this.list_route.length) {
    //     i = 0
    //   }
    // },1000*10)
  },
  // beforeDestroy(){
  //   clearInterval(this.interval)
  // },
};
</script>

<style>
</style>